{
  "common.close": "Tutup",
  "common.athleteFallback": "atlet {id}",
  "splash.title": "{app} — Visualisasi Aktivitas Beranimasi",
  "splash.tagline": "Data Strava&nbsp;Anda yang bergerak",
  "splash.demo": "Demo",
  "tab.query.title": "Peta {name}",
  "tab.query.heading": "Kueri Aktivitas:",
  "tab.query.optDays": "hari terakhir",
  "tab.query.optActivities": "aktivitas terakhir",
  "tab.query.optIds": "ID Aktivitas",
  "tab.query.optDates": "Rentang Tanggal",
  "tab.query.idsPlaceholder": "masukkan ID aktivitas di sini",
  "tab.query.after": "Dari:",
  "tab.query.before": "Sampai:",
  "tab.query.autozoom": "Zoom otomatis <i class=\"hf hf-bullseye\"></i> ke hasil kueri setelah impor",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Kueri",
  "tab.query.createAccount": "Buat akun dan/atau masuk.",
  "tab.query.sports": "Olahraga:",
  "tab.query.allSports": "Semua olahraga",
  "tab.query.sportsExcept": "Semua kecuali",
  "tab.query.sportsNone": "Tidak ada",
  "tab.query.loadingSports": "Memuat olahraga…",
  "tab.query.sportsFailed": "Tidak dapat memuat olahraga di peta ini",
  "tab.query.noSports": "Belum ada aktivitas",
  "tab.activities.title": "Aktivitas yang Ditampilkan",
  "tab.activities.clearSelection": "Hapus Pilihan",
  "tab.activities.renderSelected": "Tampilkan yang dipilih",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zoom ke pilihan",
  "tab.controls.title": "Pengaturan Lapisan",
  "tab.controls.timescale": "Skala waktu <i>&tau;</i>",
  "tab.controls.timescaleHint": "kecepatan putar",
  "tab.controls.period": "Periode <i>T</i>",
  "tab.controls.periodHint": "aktivitas ~ model",
  "tab.controls.dotSize": "Ukuran titik",
  "tab.controls.pathWidth": "Lebar jalur",
  "tab.controls.pathWidthHint": "nol menyembunyikan jalur",
  "tab.controls.colors": "Warna",
  "tab.controls.colorsHint": "putar palet",
  "tab.controls.shadows": "Bayangan",
  "tab.profile.loginTitle": "Masuk",
  "tab.profile.anonNote": "Masuk dengan Strava untuk melihat aktivitas Anda sendiri dan mengelola akun Heatflask Anda.",
  "tab.profile.loginLink": "Masuk dengan Strava",
  "tab.profile.editOnStrava": "Edit profil Anda di Strava",
  "tab.profile.indexNote": "Kami mengindeks ringkasan aktivitas Anda agar dapat diakses dengan cepat.",
  "tab.profile.viewIndex": "Lihat indeks",
  "tab.profile.sharedMaps": "Peta Bersama",
  "tab.profile.sharedMapsNote": "Mati: hanya Anda yang dapat melihat aktivitas Anda di Heatflask. Hidup: siapa pun yang memiliki tautan ke peta Anda dapat melihat aktivitas yang Anda jadikan publik di Strava. Aktivitas pribadi Anda tetap milik Anda dalam kedua kasus. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Cara kerja privasi</a>",
  "tab.profile.logout": "Keluar",
  "tab.profile.deleteAccount": "Hapus Akun",
  "tab.profile.deleteConfirm": "Hapus akun Heatflask Anda?\n\nIni akan menghapus aktivitas Anda yang telah diindeks dan mencabut akses Heatflask ke data Strava Anda. Tindakan ini tidak dapat dibatalkan.",
  "tab.profile.languageHeading": "Bahasa",
  "tab.profile.languageAuto": "Otomatis",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Bantu kami memperbaiki atau menambah terjemahan!</a>",
  "tab.profile.unitsHeading": "Satuan",
  "tab.profile.unitsAuto": "Otomatis",
  "tab.profile.unitsMetric": "Metrik (km, m)",
  "tab.profile.unitsImperial": "Imperial (mi, ft)",
  "tab.profile.textSizeHeading": "Ukuran teks",
  "tab.profile.textSmaller": "Lebih kecil",
  "tab.profile.textReset": "Normal",
  "tab.profile.textLarger": "Lebih besar",
  "tab.profile.mapDefaultsHeading": "Bawaan peta",
  "tab.profile.mapDefaultsNote": "Mulai dengan peta dasar, medan, dan pengaturan lapisan ini setiap kali Anda membuka peta yang tautannya tidak menetapkan sendiri. Tautan yang Anda bagikan tetap menampilkan persis apa yang Anda lihat.",
  "tab.profile.mapDefaultsSave": "Simpan sebagai bawaan saya",
  "tab.profile.mapDefaultsForget": "Lupakan",
  "tab.info.title": "Info",
  "tab.info.controlsHeading": "Kontrol",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + seret",
  "tab.info.shiftDragDesc": "Pilih aktivitas dalam sebuah kotak. Di layar sentuh, ketuk <i class=\"hf-object-group\"></i> terlebih dahulu, lalu seret dengan satu jari. Aktivitas terakhir yang dipilih menampilkan detailnya, dan daftar aktivitas bergulir ke sana.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + seret",
  "tab.info.ctrlDragDesc": "Putar dan miringkan peta dalam 3D, atau gunakan dua jari",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Buka atau tutup panel samping",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Tab sebelumnya atau berikutnya",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Tutup panel samping",
  "tab.info.liveUrlHeading": "URL Langsung",
  "tab.info.liveUrlDesc": "Tampilan peta dan pengaturan animasi disimpan di URL halaman, sehingga siapa pun yang Anda bagikan akan melihat tampilan yang sama.",
  "tab.info.videoHeading": "Ekspor Video",
  "tab.info.videoDesc": "Tombol <i class=\"hf-video-camera\"></i> merekam animasi sebagai MP4: ketuk tombolnya, atur kotak di atas bagian peta yang Anda inginkan, lalu ketuk lagi untuk merekam. Satu putaran penuh animasi direkam, sehingga video berulang dengan mulus; putaran yang lebih panjang dari {max} detik (video terpanjang yang diterima Strava) dipotong pada detik ke-{max}.",
  "tab.info.contributeHeading": "Berkontribusi",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Sponsori di GitHub",
  "tab.info.contactsHeading": "Kontak",
  "map.basemapAndTerrain": "Peta dasar dan medan",
  "map.pauseAnimation": "Jeda animasi",
  "map.resumeAnimation": "Lanjutkan animasi",
  "capture.record": "Rekam video (putaran {period} dtk)",
  "capture.recordTruncated": "Rekam video (satu siklus {period} dtk; hanya {max} dtk pertama yang direkam)",
  "capture.recordArea": "Rekam area di dalam kotak",
  "capture.stop": "Hentikan perekaman",
  "capture.selectionTooSmall": "pilihan terlalu kecil",
  "capture.saved": "{name} tersimpan ({size})",
  "capture.cancelled": "perekaman dibatalkan",
  "capture.failed": "perekaman gagal: {error}",
  "capture.loadingEncoder": "memuat encoder…",
  "capture.waitingForMap": "menunggu peta dimuat…",
  "capture.encoding": "mengenkode… {percent}%",
  "capture.finalizing": "menyelesaikan…",
  "share.title": "Bagikan tautan ke peta ini",
  "share.copied": "tautan disalin",
  "share.copiedUnshared": "tautan disalin — tetapi peta Anda tidak dibagikan, jadi orang lain tidak dapat membukanya. Aktifkan “Peta Bersama” untuk mengubahnya.",
  "share.unshared": "Peta Anda tidak dibagikan, jadi orang lain tidak dapat membuka tautan ini. Aktifkan “Peta Bersama” untuk mengubahnya.",
  "share.copyThis": "Salin tautan ini:",
  "update.available": "Versi baru Heatflask tersedia.",
  "update.reload": "Muat ulang",
  "import.title": "Mengimpor",
  "import.stop": "Berhenti",
  "import.stopping": "menghentikan…",
  "import.contacting": "menghubungi Strava…",
  "import.countOf": "{received} dari {total} aktivitas",
  "import.count": "{received} aktivitas",
  "import.waitStrava": "Dijeda hingga {time} karena batas unduhan Strava. Biarkan halaman ini terbuka; memuat ulang tidak mempercepat.",
  "import.waitRationed": "Unduhan cepat hari ini sudah habis. Sisanya berlanjut pukul {time}, lebih lambat. Biarkan halaman ini terbuka.",
  "import.dailyLimit": "Batas unduhan harian Strava sudah habis. Coba lagi setelah {time}.",
  "import.dailyRationed": "Jatah unduhan Strava Anda untuk hari ini sudah habis. Coba lagi setelah {time}.",
  "import.noActivitiesYet": "Akun Strava Anda belum memiliki aktivitas. Rekam atau unggah satu di Strava, dan aktivitas itu akan muncul di sini.",
  "table.noActivities": "tidak ada aktivitas",
  "table.untitled": "(tanpa judul)",
  "activities.pageTitle": "{app} — Indeks Aktivitas",
  "activities.heading": "Indeks Aktivitas",
  "activities.fetching": "Mengambil aktivitas...",
  "activities.rateLimit": "Batas permintaan Strava tercapai; dilanjutkan pada {time}",
  "activities.noData": "Maaf, tidak ada data &#128577;",
  "activities.colServerCache": "Rute tersimpan di cache server (Mongo)",
  "activities.colBrowserCache": "Rute tersimpan di cache browser ini",
  "activities.cachedServer": "Rute untuk {id} tersimpan di cache server",
  "activities.notCachedServer": "Rute untuk {id} tidak tersimpan di cache server",
  "activities.cachedBrowser": "Rute untuk {id} tersimpan di cache browser ini",
  "activities.notCachedBrowser": "Rute untuk {id} tidak tersimpan di cache browser ini",
  "sport.AlpineSki": "Ski alpen",
  "sport.BackcountrySki": "Ski lintas alam",
  "sport.Badminton": "Bulu tangkis",
  "sport.Basketball": "Bola basket",
  "sport.Canoeing": "Kano",
  "sport.Cricket": "Kriket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Menari",
  "sport.EBikeRide": "Bersepeda listrik",
  "sport.Elliptical": "Elliptical",
  "sport.EMountainBikeRide": "Bersepeda gunung listrik",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Bersepeda gravel",
  "sport.Handcycle": "Sepeda tangan",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Mendaki",
  "sport.IceSkate": "Seluncur es",
  "sport.InlineSkate": "Sepatu roda",
  "sport.Kayaking": "Kayak",
  "sport.Kitesurf": "Kitesurfing",
  "sport.MountainBikeRide": "Bersepeda gunung",
  "sport.NordicSki": "Ski lintas negara",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fisioterapi",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Bersepeda",
  "sport.RockClimbing": "Panjat tebing",
  "sport.RollerSki": "Ski roda",
  "sport.Rowing": "Dayung",
  "sport.Run": "Lari",
  "sport.Sail": "Berlayar",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Sepatu salju",
  "sport.Soccer": "Sepak bola",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stair stepper",
  "sport.StandUpPaddling": "Paddle berdiri",
  "sport.Surfing": "Selancar",
  "sport.Swim": "Renang",
  "sport.TableTennis": "Tenis meja",
  "sport.Tennis": "Tenis",
  "sport.TrailRun": "Lari lintas alam",
  "sport.Velomobile": "Velomobil",
  "sport.VirtualRide": "Bersepeda virtual",
  "sport.VirtualRow": "Dayung virtual",
  "sport.VirtualRun": "Lari virtual",
  "sport.Volleyball": "Bola voli",
  "sport.Walk": "Jalan kaki",
  "sport.WeightTraining": "Latihan beban",
  "sport.Wheelchair": "Kursi roda",
  "sport.Windsurf": "Selancar angin",
  "sport.Workout": "Latihan",
  "sport.Yoga": "Yoga"
}
